module.exports = __webpack_public_path__ + "static/media/carousel2-reduced.f7a6f4cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/carousel2-reduced.jpg
// module id = 454
// module chunks = 16